import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NavItem, PtPermissions} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-candidates-menu-item',
  template: `
    <ng-container *ngIf='(item.data | async)?.count else noData; let count'>
      <div class='alert alert-warning p-2'>
        <div class='d-flex flex-row'>
          <div (click)='clickAction.emit(this.item)' class='link-color ms-1'>
            {{ 'MESSAGE.AVAILABLE_CANDIDATES' | translate }}
            <button class='btn ms-2 btn-sm btn-warning'>
              <div class='badge bg-secondary'>{{ count }}</div>
              {{ 'BUTTON.CREATE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noData>
      <div style='height: 59px'>&nbsp;</div>
    </ng-template>

  `
})
export class CandidatesMenuItemComponent {

  @Input() item: NavItem;
  @Input() placement: string;
  @Output() clickAction = new EventEmitter<NavItem>();

  toggleClass: string[];
  isEnabled: boolean;
  PtPermissions = PtPermissions;

  constructor(private permissionService: NgxPermissionsService) {
  }

  ngOnInit(): void {
    if (this.item) {
      this.toggleClass = ['btn'];
      if (this.item.classCss) {
        this.toggleClass.push(...this.item.classCss);
      }
      this.permissionService.hasPermission(this.item.permissEnabled).then((enabled) => {
        this.isEnabled = enabled;
      });
    }
  }

}
